import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';
import { Box, Tabs, Tab } from '@mui/material';
import Layout from '../components/Layout';
import AdminSchoolSchedule from './AdminSchoolSchedule';
import AdminSchoolContracts from './AdminSchoolContracts';
import AdminSchools from './AdminSchools';

// /admin/schools — everything about schools behind one admin tile: the season
// schedule, the rental contracts, and the school list athletes pick from when
// they register. The tab lives in ?tab= so emails and the calendar can link
// straight to one, and the old /admin/school-contracts and
// /admin/school-schedule addresses redirect here.
//
// High-school coaches (role hs_coach) get the Schedule tab alone, read-only.
// The rules are what keep them out of the rest; this only decides what shows.

const TABS = [
  { key: 'schedule', label: 'Schedule', Page: AdminSchoolSchedule },
  { key: 'contracts', label: 'Contracts', Page: AdminSchoolContracts },
  { key: 'list', label: 'Registration list', Page: AdminSchools },
];

export default function AdminSchoolsHub() {
  const [params, setParams] = useSearchParams();
  const [roles, setRoles] = useState(null);
  const [mySchool, setMySchool] = useState('');
  useEffect(() => {
    const uid = auth.currentUser?.uid;
    if (!uid) { setRoles([]); return; }
    getDoc(doc(db, 'users', uid)).then(s => {
      setRoles(s.exists() ? s.data().roles || [] : []);
      setMySchool(s.exists() ? s.data().hsSchoolCode || '' : '');
    }).catch(() => setRoles([]));
  }, []);
  if (roles === null) return <Layout />;
  const coachOnly = roles.includes('hs_coach') && !roles.includes('admin');
  const tabs = coachOnly ? TABS.slice(0, 1) : TABS;
  const index = Math.max(0, tabs.findIndex(t => t.key === params.get('tab')));
  const { Page } = tabs[index];

  return (
    <Layout>
      <Box sx={{ px: { xs: 1.5, sm: 3 }, pt: 2, borderBottom: '1px solid #e0e0e0' }}>
        <Tabs value={index} variant="scrollable" scrollButtons="auto"
          onChange={(e, i) => setParams({ tab: tabs[i].key }, { replace: true })}>
          {tabs.map(t => <Tab key={t.key} label={t.label} />)}
        </Tabs>
      </Box>
      <Page embedded readOnly={coachOnly} mySchool={coachOnly ? mySchool : ''} />
    </Layout>
  );
}
